import React from 'react';
import * as styles from './heading-cover.module.css';

const HeadingCover = ({ className='', children }) => {
  return (
    <h1 className={`${styles.heading} ${className}`}>
      {children}
    </h1>
  );
};

export default HeadingCover;